import { useId } from 'react';
import type { SampleDataSkippedItem } from '../../types/sampleData';
import './OrganizationSampleDataPanel.css';

interface SampleDataSkippedListProps {
  items: SampleDataSkippedItem[];
}

/** The sample records removal leaves in place, each with the reason it stays. */
export const SampleDataSkippedList = ({ items }: SampleDataSkippedListProps) => {
  const titleId = useId();
  if (items.length === 0) return null;

  return (
    <div className="org-sample-data__skipped" data-testid="sample-data-skipped">
      <p className="org-sample-data__skipped-title" id={titleId}>
        These stay because coaches changed them:
      </p>
      <ul className="org-sample-data__skipped-list" aria-labelledby={titleId}>
        {items.map((item, index) => (
          <li key={`${item.entityType}-${item.label}-${index}`}>
            <span className="org-sample-data__skipped-label">{item.label || item.entityType}</span>
            {item.reason && <span className="org-sample-data__skipped-reason">: {item.reason}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
};
